/*
 * ****************************************************************
 * File: index.js
 * Project: CPaaS
 * Owner: Radisys
 *
 * Copyright - 2021 Radisys Corporation.
 * All rights reserved. No part of this software may be used or
 * reproduced in any form by any means without the prior written
 * permission of Radisys Corporation.
 *
 * Author: Prathik Pai
 *
 * ****************************************************************
 */
import React from "react";
import { Switch, Route } from "react-router-dom";
import Home from "../pages/home/callCard";
import CallProgress from "../pages/call/callInProgress";
import Promovideo from "../pages/promovideo/promovideo";
import PropTypes from "prop-types";

export default function Main({
  remoteURI,
  setRemoteURI,
  session,
  makeCall,
  acceptCall,
  endCall,
  debugLogs,
  connectionStatusColor,
  connection,
  upgrade,
  localStream,
  remoteStream,
  engageClient,
  collocation,
  setCollocation,
  conferenceLayout,
  setCallDate,
  toggleTranscribe,
  setToggleTranscribe
}) {
  return (
    <div>
      <Switch>
        <Route
          exact
          path="/home"
          component={() => (
            <Home
              collocation={collocation}
              remoteURI={remoteURI}
              setRemoteURI={setRemoteURI}
              session={session}
              makeCall={makeCall}
              acceptCall={acceptCall}
              debugLogs={debugLogs}
              connectionStatusColor={connectionStatusColor}
              connection={connection}
              setCallDate={setCallDate}
            />
          )}
        />
        <Route
          exact
          path="/callinprogress"
          component={() => (
            <CallProgress
              collocation={collocation}
              setCollocation={setCollocation}
              localStream={localStream}
              remoteStream={remoteStream}
              session={session}
              endCall={endCall}
              acceptCall={acceptCall}
              upgrade={upgrade}
              debugLogs={debugLogs}
              engageClient={engageClient}
              conferenceLayout={conferenceLayout}
              toggleTranscribe = {toggleTranscribe}
              setToggleTranscribe={setToggleTranscribe}
            />
          )}
        />
        <Route
          exact
          path="/callinprogress."
          component={() => (
            <Promovideo session={session} setCollocation={setCollocation} />
          )}
        />
      </Switch>
    </div>
  );
}

Main.propTypes = {
  remoteURI: PropTypes.string.isRequired,
  setRemoteURI: PropTypes.func.isRequired,
  session: PropTypes.any,
  makeCall: PropTypes.any,
  acceptCall: PropTypes.any,
  endCall: PropTypes.any,
  debugLogs: PropTypes.any,
  connectionStatusColor: PropTypes.object.isRequired,
  connection: PropTypes.object.isRequired,
  upgrade: PropTypes.any,
  localStream: PropTypes.any,
  remoteStream: PropTypes.any,
  engageClient: PropTypes.any,
  collocation: PropTypes.any,
  setCollocation: PropTypes.any,
  conferenceLayout: PropTypes.any,
  setCallDate: PropTypes.any,
  toggleTranscribe: PropTypes.any,
  setToggleTranscribe: PropTypes.any
};
